import { fromJS } from 'immutable';

import { SET_GC, UPDATE_GC_AMOUNT, UPDATE_GC_BARBER } from './constants';

const initialState = fromJS({
  amount: 0,
  barber: null,
  giftCard: null,
});

export default function giftCardReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_GC_AMOUNT: return state.withMutations(s => s.set('amount', action.payload));
    case UPDATE_GC_BARBER: return state.withMutations(s => s.set('barber', action.payload));
    case SET_GC: return state.withMutations(s => s.set('giftCard', action.payload));
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/giftCard/reducer.js